import React from "react";
import { Box } from "@mui/material";
import Clipboard from "../clipboard/Clipboard";
import { btc, sats, yourLnAddress } from "../messages";
import Text from "../text/Text";
import { useSelector } from "react-redux";

function LnAddress({ userName, isSuccess, isFromBrowser }) {
  const { uuid: currency } = useSelector((state) => state.common.taprootAsset);

  const textSize = isFromBrowser ? 16 : 14;
  return (
    <Box className="set-username" sx={{ bottom: isSuccess ? "95px" : "126px" }}>
      <Text className="default-text" size={14} font="regular">
        {yourLnAddress(currency === sats ? btc : currency)}
      </Text>
      <Text
        className={`default-text ${isSuccess && "ln-address-with-username"}`}
        size={textSize}
        font="semibold"
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        <Text className="username-val" size={textSize} font="semibold">
          {userName || "test"}
        </Text>
        {`@${process.env.REACT_APP_DOMAIN}`}
        {isSuccess && (
          <Clipboard text={`${userName}@${process.env.REACT_APP_DOMAIN}`} />
        )}
      </Text>
    </Box>
  );
}

export default LnAddress;
